import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'

function OtherOfferSvg({ size, testID, accessibilityLabel, color }: AccessibleIcon) {
  return (
    <AccessibleSvg
      width={size}
      height={size}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      viewBox="0 0 48 49">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2515 6.5C22.0537 6.5 21.1463 7.42361 21.1463 8.5V40.5C21.1463 41.5764 22.0537 42.5 23.2515 42.5H41.8918C43.0897 42.5 43.9971 41.5764 43.9971 40.5V18.09C43.9971 17.5377 44.4455 17.09 44.9986 17.09C45.5516 17.09 46 17.5377 46 18.09V40.5C46 42.7436 44.1321 44.5 41.8918 44.5H23.2515C21.0113 44.5 19.1434 42.7436 19.1434 40.5V8.5C19.1434 6.25639 21.0113 4.5 23.2515 4.5H41.8918C44.1321 4.5 46 6.25639 46 8.5V11.09C46 11.6423 45.5516 12.09 44.9986 12.09C44.4455 12.09 43.9971 11.6423 43.9971 11.09V8.5C43.9971 7.42361 43.0897 6.5 41.8918 6.5H23.2515ZM16.7234 7.99907C16.8622 8.53368 16.5407 9.07942 16.0053 9.218L10.5588 10.6278C9.4169 10.9243 8.78827 12.0371 9.07636 13.0722L17.0194 41.7131C17.1671 42.2454 16.8546 42.7963 16.3216 42.9437C15.7886 43.0911 15.2368 42.7791 15.0892 42.2469L7.14661 13.6078C6.5445 11.4432 7.88343 9.25571 10.055 8.69215L15.5027 7.28199C16.0381 7.14341 16.5846 7.46445 16.7234 7.99907ZM5.04707 24.2435C5.53017 23.9746 5.70351 23.3656 5.43423 22.8832C5.16495 22.4008 4.55502 22.2277 4.07192 22.4966C2.10236 23.5928 1.40228 26.0546 2.56116 27.9838L2.56171 27.9847L10.6381 41.4829C10.9218 41.9571 11.5367 42.1118 12.0115 41.8285C12.4863 41.5452 12.6412 40.9313 12.3575 40.4572L4.28006 26.9572L4.27902 26.9554C3.71962 26.0247 4.03449 24.8071 5.04707 24.2435Z"
        fill={color}
      />
    </AccessibleSvg>
  )
}

export const OtherOffer = styled(OtherOfferSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.colors.black,
  size: size ?? theme.icons.sizes.standard,
}))``
